import { RolePermissionCoreBase } from "./role-permission.core.base"


export class RolePermissionCore extends RolePermissionCoreBase {

}